import React from 'react';

import CustomLink from 'components/CustomLink';

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  id?: string;
  className?: string;
};

// Optional SMS consent opt-in (A2P 10DLC). Unchecked by default. Mirrors the
// existing "Keep me updated" checkbox styling (registerMode.tsx) — items-start +
// flex-shrink-0 because this label wraps several lines and the box must not
// shrink (its :after visual is a fixed 28px). Font size is inherited from the
// parent form (pass via className) so it matches each form's own text.
const SmsConsentCheckbox: React.FC<Props> = ({
  checked,
  onChange,
  id = 'SmsConsent',
  className = 'mt-[14px]',
}) => (
  <div className={`flex items-start ${className}`}>
    <input
      type="checkbox"
      id={id}
      name={id}
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      className="mr-3 flex-shrink-0 input-checkbox custom-checkbox cursor-pointer"
    />
    <label htmlFor={id} className="cursor-pointer">
      <span className="font-sohneKraftig">It&apos;s OK to text me.</span> By
      checking this box, I consent to receive text messages related to real
      estate services from Condo Black Book LLC. You can
      reply &quot;STOP&quot; at any time to opt-out. Message and data rates may
      apply. Message frequency may vary, text HELP to (305) 697-7667 for
      assistance. For more information, please refer to our{' '}
      <CustomLink
        target="_blank"
        href="/privacy-policy/"
        className="text-underline text-gold-darker"
      >
        Privacy Policy
      </CustomLink>{' '}
      and{' '}
      <CustomLink
        target="_blank"
        href="/terms-of-use/"
        className="text-underline text-gold-darker"
      >
        SMS Terms and Conditions
      </CustomLink>{' '}
      on our website.
    </label>
  </div>
);

export default SmsConsentCheckbox;
